import { render } from "./ShowQuotation.vue?vue&type=template&id=ccf0f916"
import script from "./ShowQuotation.vue?vue&type=script&lang=js"
export * from "./ShowQuotation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__